export default __webpack_public_path__ + "static/media/business255.66d04382.png";